export const SET_PLC_POPUP_STATUS = "SET_PLC_POPUP_STATUS";
export const SET_PLC_POPUP_STATUS_SUCCESS = "SET_PLC_POPUP_STATUS_SUCCESS";
export const SET_PLC_POPUP_STATUS_ERROR = "SET_PLC_POPUP_STATUS_ERROR";
